import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
    "providedIn": "root"
  })
  @Pipe({
    name: 'agingstatus',
    standalone: true
  })
export class AgingStatusPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case 1:
                return 'Current';
            case 2:
                return 'Over30';
            case 3:
                return 'Over60';
            case 4:
                return 'Over90';
            default:
                return '';
        }
    }
}
